// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._benefitsFootnote__paragraph_1bz9p_1 > bdi {
  display: flex;
}
._benefitsFootnote__paragraph_1bz9p_1.ant-5_24_1-typography.perxis-auto-1_19_6-typography.perxis-auto-1_19_6-paragraph {
  margin: var(--perxis-auto-gap-vertical-green-inner) 0 0 0;
}
._benefitsFootnote__paragraph_1bz9p_1.ant-5_24_1-typography.perxis-auto-1_19_6-typography.perxis-auto-1_19_6-paragraph:first-child {
  margin-top: 0;
}
._benefitsFootnote__text_1bz9p_10 > bdi {
  display: flex;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
